import { ClaimStatuses } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { Item } from "@ui-components/filter-bar/FilterBar.types.ts";

import {
  useClaimsFilterDatesPicker,
  useClaimsListFilterClaimPicker,
  useClaimsListFilterContactPicker,
  useClaimsListFilterProviderPicker
} from "../claims/components/claims-filter/claims-filter-items.tsx";
import { AccErrorLogsFilterValues } from "./AccErrorLogsFilter.types.ts";

export const useAccErrorLogsFilterItems =
  (): Item<AccErrorLogsFilterValues>[] => {
    const { acc } = useStores();

    const statusesRefData = acc.ref.claimStatuses;

    return [
      useClaimsListFilterContactPicker(),
      useClaimsListFilterClaimPicker(),
      useClaimsListFilterProviderPicker(),
      {
        type: "optionsSelect",
        name: "claimStatusCode",
        props: {
          id: "claim-filter-status",
          placeholder: "Status",
          options: [
            {
              key: ClaimStatuses.AuthenticationError,
              text:
                statusesRefData.get(ClaimStatuses.AuthenticationError)?.text ??
                "Authentication error"
            },
            {
              key: ClaimStatuses.CommunicationError,
              text:
                statusesRefData.get(ClaimStatuses.CommunicationError)?.text ??
                "Communication error"
            },
            {
              key: ClaimStatuses.Error,
              text:
                statusesRefData.get(ClaimStatuses.Error)?.text ?? "Lodge error"
            },
            {
              key: ClaimStatuses.ProcessingError,
              text:
                statusesRefData.get(ClaimStatuses.ProcessingError)?.text ??
                "Processing error"
            },
            {
              key: ClaimStatuses.GetStatusError,
              text:
                statusesRefData.get(ClaimStatuses.GetStatusError)?.text ??
                "Query error"
            },
            {
              key: ClaimStatuses.ValidationError,
              text:
                statusesRefData.get(ClaimStatuses.ValidationError)?.text ??
                "Validation error"
            }
          ],
          multiSelect: true,
          hideSearchOption: true,
          calloutWidth: 300
        }
      },
      useClaimsFilterDatesPicker()
    ];
  };
